import FirstServiceDiscountDisclaimer from './FirstServiceDiscountDisclaimer';

export default FirstServiceDiscountDisclaimer;
